module.exports = __webpack_public_path__ + "img/background.7b938528.jpg";